var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.loading
    ? _c(
        "div",
        {
          staticClass: "ci-card p-3 p-md-4",
          attrs: { id: "terms-and-conditions" },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("ci-button", {
                staticClass: "d-none d-lg-flex",
                attrs: {
                  variant: "ghost-primary",
                  size: "lg",
                  label: _vm.$t("print"),
                  icon: "mdi-printer",
                },
                on: {
                  click: function ($event) {
                    return _vm.printPage()
                  },
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "row" }, [
            _c("div", {
              staticClass: "col-12 col-xxl-8",
              domProps: { innerHTML: _vm._s(_vm.content) },
            }),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }